import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a30f3e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "courseDetailBox"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "详情内容", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_4 = ["innerHTML"];
import { ref, watch } from "vue";
import { marked } from "marked";
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDesignDetailContent',
  props: {
    courseDetail: {}
  },
  setup(__props) {
    const formatterContent = ref('');
    const props = __props;
    watch([() => props.courseDetail], ([newVal]) => {
      if (newVal && newVal.overview) {
        //markdown格式转为html格式
        const content = marked.parse(newVal.overview);
        formatterContent.value = content;
      }
    });
    return (_ctx, _cache) => {
      const _directive_highlight = _resolveDirective("highlight");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: formatterContent.value
      }, null, 8, _hoisted_4), [[_directive_highlight]])]);
    };
  }
});